// ════════════════════════════════════════════════════════════════════
// Glass-i — Stage SALES-PROFORMA-APPROVAL-1 approval API client.
// The approver-facing surface: inbox + L1 / L2 / L3 decisions. Mirrors the
// proformaApi axios + unwrap() pattern.
// ════════════════════════════════════════════════════════════════════

import client from '../../../../api/client';

const BASE = '/api/erp/sales/proforma-approvals';

function unwrap(resp) {
  return resp && resp.data && resp.data.data !== undefined ? resp.data.data : (resp ? resp.data : null);
}
const enc = encodeURIComponent;

export const proformaApprovalApi = {
  inbox: (params = {}) => client.get(`${BASE}/inbox`, { params }).then(unwrap),
  inboxCounts: () => client.get(`${BASE}/inbox/counts`).then(unwrap),

  // L1 — status-change decision.
  l1Approve: (requestId, remarks) => client.post(`${BASE}/${enc(requestId)}/l1/approve`, { remarks }).then(unwrap),
  l1Reject: (requestId, reason) => client.post(`${BASE}/${enc(requestId)}/l1/reject`, { reason }).then(unwrap),

  // L2 — accounts decision.
  accountsApprove: (requestId, body = {}) => client.post(`${BASE}/${enc(requestId)}/accounts/approve`, body).then(unwrap),
  accountsReject: (requestId, reason) => client.post(`${BASE}/${enc(requestId)}/accounts/reject`, { reason }).then(unwrap),
  accountsHold: (requestId, reason) => client.post(`${BASE}/${enc(requestId)}/accounts/hold`, { reason }).then(unwrap),
  accountsEscalate: (requestId, body = {}) => client.post(`${BASE}/${enc(requestId)}/accounts/escalate-l3`, body).then(unwrap),

  // L3 — super-admin credit override.
  l3Approve: (requestId, superAdminReason) => client.post(`${BASE}/${enc(requestId)}/l3/approve`, { superAdminReason }).then(unwrap),
  l3Reject: (requestId, reason) => client.post(`${BASE}/${enc(requestId)}/l3/reject`, { reason }).then(unwrap)
};

export default proformaApprovalApi;
